export default __webpack_public_path__ + "static/O0302-b68bd2a416e0c277144f11b4caed6470.png";